import getSessionId from '@common/helpers/session-id';

export const LS_CID = "cid";

export function initCidTracking() {
    try {
        var cidObject = getCidObject();
        if (!cidObject) {
            resetCid();
        }
        else {
            if (cidObject.s !== getSessionId()) {
                resetCid();
            }
        }
    }
    catch (e) {
        return;
    }
}

export function getCidObject() {
    try {
        return JSON.parse(localStorage.getItem(LS_CID));
    } catch (e) {
        return {};
    }
}

export function saveCidObject(CidObject) {
    return localStorage.setItem(LS_CID, JSON.stringify(CidObject));
}

export function newCidObject(sessId) {
    return {
        s: sessId,
        cid:[]
    };
}

export function resetCid() {
    saveCidObject(newCidObject(getSessionId()));
}